export interface CancellationsAndRefundsPageContent {
  pageTitle: string
  policies: { text: React.ReactNode }[]
  contactInfo: {
    phone: {
      number: string
      href: string
    }
    email: {
      address: string
      href: string
    }
    address: {
      company: string
      street: string
      city: string
    }
  }
}

const pageTitle = 'Cancellation & Refund Policies'

const policies = [
  {
    text: `We get it - plans change. Whether your trip's been delayed,
     cancelled, or rerouted, we're here to make adjusting your shipment
      as simple as possible.`,
  },
  {
    text: <strong>If you need to cancel:</strong>,
  },
  {
    text: (
      <ul className="list-disc pl-6">
        <li>
          <strong>More than 48 hours before pickup:</strong> You&apos;ll receive a full refund back
          to your original payment method.
        </li>
      </ul>
    ),
  },
  {
    text: (
      <em>
        Most refunds are processed within 5 business days, though it can take up to 30 days to
        appear on your card statement.
      </em>
    ),
  },
  {
    text: <strong>Within 48 hours of pickup:</strong>,
  },
  {
    text: (
      <ul className="list-disc pl-6">
        <li>
          <strong>Full cancellation:</strong> You&apos;ll receive an account credit for your
          shipment total, minus $10 per package.
        </li>
        <li>
          <strong>Partial cancellation</strong> (like canceling just one leg of a round trip):
          You&apos;ll receive a $10 account credit per package.
        </li>
      </ul>
    ),
  },
  {
    text: (
      <ul className="list-disc pl-6">
        <li>
          <em>Account credits never expire and can be used anywhere on our site.</em>
        </li>
      </ul>
    ),
  },
  {
    text: <strong>If you need to change your pickup date or time:</strong>,
  },
  {
    text: (
      <ul className="list-disc pl-6">
        <li>
          <strong>3+ business days before pickup:</strong> Free to change.
        </li>
        <li>
          <strong>Between 3 business days and 24 hours before pickup:</strong> $25 change fee, plus
          any difference in shipping rate.
        </li>
        <li>
          <strong>Within 24 hours of pickup:</strong> A higher change fee (more than $25) may apply,
          plus any difference in rate.
        </li>
      </ul>
    ),
  },
  {
    text: (
      <>
        For more information, please visit our full{' '}
        <a href="/terms" className="text-blue-600 underline hover:text-blue-800">
          Terms and Conditions
        </a>
        .
      </>
    ),
  },
]

const contactInfo = {
  phone: {
    number: '1-855-867-9915',
    href: 'tel:1-855-867-9915',
  },
  email: {
    address: 'accounting@ShipSticks.com',
    href: 'mailto:accounting@ShipSticks.com',
  },
  address: {
    company: 'Ship Sticks',
    street: '11400 N. Jog Road, Suite 300',
    city: 'Palm Beach Gardens, Florida 33418',
  },
}

const content: CancellationsAndRefundsPageContent = {
  pageTitle,
  policies,
  contactInfo,
}

export default content
